import { render, staticRenderFns } from "./EmployerMatchTrueUpCalculateRadio.vue?vue&type=template&id=080d1080&"
import script from "./EmployerMatchTrueUpCalculateRadio.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchTrueUpCalculateRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports